// 모바일 헤더 따로 들어가는 경우 :  meta: { mobileHd: true },
// 모바일 헤더에 찜하기 버튼 있는 경우 : meta: { likeBtn: true },
// 인하대 페이지일 경우 : meta: { site: 'inha' }
const mainRoutes = [
  {
    path: "main",
    name: "staffMain",
    meta: {
      title: "운영자 메인",
      isDynamic: true,
      site: "dongwon",
    },
    component: () => import("@/views/staff/main/StaffMainIndex-dongwon.vue"),
  },
  {
    path: "recentFeed",
    name: "staffRecentFeed",
    meta: {
      title: "최신 알림",
      mobileTitle: "최신 알림",
      mobileHd: true,
      homeBtn: true,
      gnbBtn: true,
      site: "dongwon",
    },
    component: () => import("@/views/common/main/RecentFeed.vue"),
  },
  {
    path: "recentFeed/detail",
    name: "staffRecentFeedDetail",
    meta: {
      title: "알림 목록",
      mobileTitle: "알림 목록",
      mobileHd: true,
      site: "dongwon",
    },
    component: () => import("@/views/common/main/RecentFeedDetail.vue"),
  },
];
export default mainRoutes;
